// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.past-throws {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 40px 80px;
}

.past-throws-header {
  text-align: center;
  margin-bottom: 48px;
}

.past-throws-title {
  font-family: var(--font-display);
  font-size: clamp(48px, 8vw, 100px);
  color: var(--gold);
  text-transform: uppercase;
  line-height: 1;
  margin-bottom: 12px;
}

.past-throws-subtitle {
  font-family: var(--font-body);
  font-size: clamp(14px, 1.4vw, 20px);
  color: var(--dark);
  opacity: 0.7;
}

.admin-hint {
  font-family: var(--font-body);
  font-size: 14px;
  color: var(--text-light);
  margin-top: 12px;
  font-style: italic;
}

/* Masonry via CSS columns */

.gallery-masonry {
  column-count: 3;
  column-gap: 16px;
}

.gallery-item {
  position: relative;
  page-break-inside: avoid;
  break-inside: avoid;
  margin-bottom: 16px;
}

.gallery-image {
  width: 100%;
  border-radius: 12px;
  display: block;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.gallery-item:not(.gallery-item-admin):hover .gallery-image {
  transform: scale(1.02);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

/* Admin drag-and-drop */

.gallery-item-admin {
  cursor: grab;
  transition: opacity 0.2s ease, transform 0.15s ease;
}

.gallery-item-admin:active {
  cursor: grabbing;
}

.gallery-item-admin .gallery-image {
  pointer-events: none;
}

.gallery-item-admin.dragging {
  opacity: 0.3;
  transform: scale(0.96);
}

.gallery-item-admin.drag-over {
  transform: scale(1.03);
  box-shadow: 0 0 0 3px var(--gold, #b5a36a);
  border-radius: 12px;
}

/* Delete button */

.gallery-delete-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  font-size: 18px;
  line-height: 1;
  color: var(--error, #c00);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease, background-color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gallery-item-admin:hover .gallery-delete-btn {
  opacity: 1;
}

.gallery-delete-btn:hover {
  background: white;
}

/* Upload area */

.gallery-upload-area {
  position: relative;
  margin-top: 32px;
}

.gallery-upload-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 28px;
  border: 2px dashed var(--border, #ccc);
  border-radius: 12px;
  cursor: pointer;
  color: var(--text-light, #999);
  font-family: var(--font-body);
  font-size: 15px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.gallery-upload-btn:hover {
  border-color: var(--gold);
  color: var(--gold);
  background: rgba(0, 0, 0, 0.02);
}

.gallery-upload-btn.uploading {
  pointer-events: none;
  opacity: 0.6;
}

.upload-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  z-index: 2;
  font-family: var(--font-body);
  font-size: 14px;
  color: var(--dark);
}

.upload-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--border, #ccc);
  border-top-color: var(--gold, #b5a36a);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Responsive column count */

@media (max-width: 1000px) {
  .gallery-masonry {
    column-count: 3;
  }
}

@media (max-width: 768px) {
  .past-throws {
    padding: 20px 16px 60px;
  }

  .past-throws-header {
    margin-bottom: 32px;
  }

  .gallery-masonry {
    column-count: 2;
    column-gap: 10px;
  }

  .gallery-item {
    margin-bottom: 10px;
  }

  .gallery-image {
    border-radius: 8px;
  }
}

@media (max-width: 480px) {
  .gallery-masonry {
    column-count: 1;
  }

  .gallery-item {
    margin-bottom: 12px;
  }
}

@media (min-width: 1200px) {
  .gallery-masonry {
    column-count: 4;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PastThrows.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,4BAA4B;;AAE5B;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,wBAAwB;;AAExB;EACE,YAAY;EACZ,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,kBAAkB;;AAElB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,UAAU;EACV,yDAAyD;EACzD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;;AAEhB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,4BAA4B;;AAE5B;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".past-throws {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px 40px 80px;\n}\n\n.past-throws-header {\n  text-align: center;\n  margin-bottom: 48px;\n}\n\n.past-throws-title {\n  font-family: var(--font-display);\n  font-size: clamp(48px, 8vw, 100px);\n  color: var(--gold);\n  text-transform: uppercase;\n  line-height: 1;\n  margin-bottom: 12px;\n}\n\n.past-throws-subtitle {\n  font-family: var(--font-body);\n  font-size: clamp(14px, 1.4vw, 20px);\n  color: var(--dark);\n  opacity: 0.7;\n}\n\n.admin-hint {\n  font-family: var(--font-body);\n  font-size: 14px;\n  color: var(--text-light);\n  margin-top: 12px;\n  font-style: italic;\n}\n\n/* Masonry via CSS columns */\n\n.gallery-masonry {\n  column-count: 3;\n  column-gap: 16px;\n}\n\n.gallery-item {\n  position: relative;\n  break-inside: avoid;\n  margin-bottom: 16px;\n}\n\n.gallery-image {\n  width: 100%;\n  border-radius: 12px;\n  display: block;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.gallery-item:not(.gallery-item-admin):hover .gallery-image {\n  transform: scale(1.02);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n/* Admin drag-and-drop */\n\n.gallery-item-admin {\n  cursor: grab;\n  transition: opacity 0.2s ease, transform 0.15s ease;\n}\n\n.gallery-item-admin:active {\n  cursor: grabbing;\n}\n\n.gallery-item-admin .gallery-image {\n  pointer-events: none;\n}\n\n.gallery-item-admin.dragging {\n  opacity: 0.3;\n  transform: scale(0.96);\n}\n\n.gallery-item-admin.drag-over {\n  transform: scale(1.03);\n  box-shadow: 0 0 0 3px var(--gold, #b5a36a);\n  border-radius: 12px;\n}\n\n/* Delete button */\n\n.gallery-delete-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  border-radius: 50%;\n  font-size: 18px;\n  line-height: 1;\n  color: var(--error, #c00);\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.2s ease, background-color 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.gallery-item-admin:hover .gallery-delete-btn {\n  opacity: 1;\n}\n\n.gallery-delete-btn:hover {\n  background: white;\n}\n\n/* Upload area */\n\n.gallery-upload-area {\n  position: relative;\n  margin-top: 32px;\n}\n\n.gallery-upload-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 28px;\n  border: 2px dashed var(--border, #ccc);\n  border-radius: 12px;\n  cursor: pointer;\n  color: var(--text-light, #999);\n  font-family: var(--font-body);\n  font-size: 15px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.gallery-upload-btn:hover {\n  border-color: var(--gold);\n  color: var(--gold);\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.gallery-upload-btn.uploading {\n  pointer-events: none;\n  opacity: 0.6;\n}\n\n.upload-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.85);\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  z-index: 2;\n  font-family: var(--font-body);\n  font-size: 14px;\n  color: var(--dark);\n}\n\n.upload-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid var(--border, #ccc);\n  border-top-color: var(--gold, #b5a36a);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Responsive column count */\n\n@media (max-width: 1000px) {\n  .gallery-masonry {\n    column-count: 3;\n  }\n}\n\n@media (max-width: 768px) {\n  .past-throws {\n    padding: 20px 16px 60px;\n  }\n\n  .past-throws-header {\n    margin-bottom: 32px;\n  }\n\n  .gallery-masonry {\n    column-count: 2;\n    column-gap: 10px;\n  }\n\n  .gallery-item {\n    margin-bottom: 10px;\n  }\n\n  .gallery-image {\n    border-radius: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .gallery-masonry {\n    column-count: 1;\n  }\n\n  .gallery-item {\n    margin-bottom: 12px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .gallery-masonry {\n    column-count: 4;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
